import axios from "axios";
import Baseurl from "../Baseurl/Baseurl";


const GetProfiledetail=(id)=>Baseurl.get(`/employeeloginboth/${id}`);

export {
    GetProfiledetail
}